import { render } from "./ProductCategoryMetaData.vue?vue&type=template&id=140430a8&scoped=true"
import script from "../js/product-category-meta-data.js?vue&type=script&lang=js"
export * from "../js/product-category-meta-data.js?vue&type=script&lang=js"

import "./ProductCategoryMetaData.vue?vue&type=style&index=0&id=140430a8&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140430a8"]])

export default __exports__